// extracted by mini-css-extract-plugin
export default {"link":"ItemNameLink_link__Ii8+-"};